import React from 'react';
import styled from "styled-components";

import Utils from '../../common/Utils';

const HorizontalAxis = styled.div`
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    height: 0.15rem;
    width: 100%;
    background-color: grey;
    z-index: 40;
`;

const VerticalAxis = styled.div`
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    width: 0.15rem;
    height: 100%;
    background-color: grey;
    z-index: 30;
`;

export class Graphics {

    static horizontal_axis = (top, color = "grey", line_width = "0.15rem") => {
        const style = {
            top: top,
            backgroundColor: color,
            height: line_width
        }
        return <HorizontalAxis key={Utils.random_id()} style={style}/>
    }

    static vertical_axis = (left, color = "grey", line_width = "0.15rem") => {
        const style = {
            left: left,
            backgroundColor: color,
            width: line_width
        }
        return <VerticalAxis key={Utils.random_id()} style={style}/>
    }
}

export default Graphics;
